// Toggle search panel
document.querySelector(".search-toggle").addEventListener("click", () => {
  document.querySelector(".slide-out-search-panel").classList.add("active");
  document.querySelector(".search-overlay").classList.add("active");
  document.querySelector(".header-wrapper").classList.add("active");
  // Add focus to the search input
  setTimeout(() => {
    document.querySelector(".search-input").focus();
  }, 100);
});

// Close panel
document.querySelector(".close-search").addEventListener("click", () => {
  document.querySelector(".slide-out-search-panel").classList.remove("active");
  document.querySelector(".search-overlay").classList.remove("active");
  document.querySelector(".header-wrapper").classList.remove("active");
});

document.querySelector(".search-overlay").addEventListener("click", () => {
  document.querySelector(".slide-out-search-panel").classList.remove("active");
  document.querySelector(".search-overlay").classList.remove("active"); // Hide overlay
  document.querySelector(".header-wrapper").classList.remove("active");
});

// Toggle cart panel
document.querySelector("#cart-icon-bubble").addEventListener("click", () => {
  document.querySelector(".header-wrapper").classList.add("active");
});

// Close panel
document.querySelector(".drawer__close").addEventListener("click", () => {
  document.querySelector(".header-wrapper").classList.remove("active");
});

document.querySelector("#CartDrawer-Overlay").addEventListener("click", () => {
  document.querySelector(".header-wrapper").classList.remove("active");
});

// Debounce function to limit the frequency of API calls
function debounce(func, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
}

// Fetch and display search results
async function fetchSearchResults(query, resultsContainer) {
  if (!query) {
    resultsContainer.innerHTML = "<p>Please enter a search term.</p>";
    return;
  }

  try {
    const response = await fetch(
      `/search?q=${encodeURIComponent(query)}&type=product&view=json`,
      {
        headers: {
          Accept: "application/json", // Explicitly request JSON
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseText = await response.text();
    const data = JSON.parse(responseText);

    if (
      !data.results ||
      data.results.length === 0 ||
      data.results[0]?.message === "No results found"
    ) {
      resultsContainer.innerHTML = "<p>No results found.</p>";
      return;
    }

    console.log("Original search results:", data.results);

    // Create expanded results with only color variants
    const expandedResults = [];

    data.results.forEach((product) => {
      // Find color option
      let colorOption = null;
      if (product.options && Array.isArray(product.options)) {
        colorOption = product.options.find(
          (option) =>
            option.name.toLowerCase().includes("color") ||
            option.name.toLowerCase().includes("colour")
        );
      }

      if (colorOption && product.variants && product.variants.length > 0) {
        // Get unique color values
        const colorPosition = colorOption.position - 1; // Shopify options are 1-indexed
        const seenColors = new Set();

        // For each color, find the first variant with that color
        product.variants.forEach((variant) => {
          if (!variant.options || !Array.isArray(variant.options)) return;

          const color = variant.options[colorPosition];
          if (!color || seenColors.has(color)) return;

          seenColors.add(color);

          // Find the matching color image if available
          let colorImage = variant.image || product.image;
          if (product.color_images && Array.isArray(product.color_images)) {
            const colorMatch = product.color_images.find(
              (img) => img.color === color
            );
            if (colorMatch && colorMatch.image_url) {
              // Use the image URL but replace the width if needed
              colorImage = colorMatch.image_url.replace(
                /width=\d+/,
                "width=493"
              );
            }
          }

          expandedResults.push({
            ...product,
            variantId: variant.id,
            variantColor: color,
            variantImage: colorImage,
            variantPrice: variant.price || product.price,
            variantAvailable: variant.available,
          });
        });
      } else {
        // No color variants, add the original product
        expandedResults.push(product);
      }
    });

    console.log("Expanded results with color variants:", expandedResults);

    const resultsHTML = expandedResults
      .map(
        (item) => `
        <div class="search-result-item${
          !item.variantAvailable ? " sold-out" : ""
        }">
          <a href="${item.url}${
          item.variantId ? "?variant=" + item.variantId : ""
        }">
            <div class="search-result-item__image">
              <img src="${item.variantImage || item.image}" alt="${
          item.title
        } ${item.variantColor || ""}" loading="lazy">
            </div>
            <div class="search-result-item__info">
              <span>${
                item.variantColor
                  ? `${item.title} ${item.variantColor}`
                  : item.title
              }</span>
              <p class="price">${item.variantPrice || item.price}</p>
              ${
                !item.variantAvailable
                  ? '<span class="sold-out-label">Sold Out</span>'
                  : ""
              }
            </div>
          </a>
        </div>
      `
      )
      .join("");

    resultsContainer.innerHTML = resultsHTML;
  } catch (error) {
    console.error("Error fetching search results:", error);
    resultsContainer.innerHTML = `<p>Error loading results. Please try again. ${error.message}</p>`;
  }
}

// Attach live search functionality
document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.querySelector(
    ".search-panel-inner input[name='q']"
  );
  const resultsContainer = document.querySelector(".search-results-container");

  if (searchInput && resultsContainer) {
    // Use debounce to limit API calls
    const debouncedFetch = debounce((query) => {
      fetchSearchResults(query, resultsContainer);
    }, 300);

    // Listen for input events
    searchInput.addEventListener("input", (e) => {
      const query = e.target.value.trim();
      debouncedFetch(query);
    });
  }
});

// Fallback for form submission (if needed)
document
  .querySelector(".search-panel-inner form")
  .addEventListener("submit", async (e) => {
    e.preventDefault();
    const query = e.target.q.value.trim();
    const resultsContainer = document.querySelector(
      ".search-results-container"
    );

    if (!query) {
      resultsContainer.innerHTML = "<p>Please enter a search term.</p>";
      return;
    }

    try {
      const response = await fetch(
        `/search?q=${encodeURIComponent(query)}&type=product&view=json`,
        {
          headers: {
            Accept: "application/json", // Explicitly request JSON
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseText = await response.text();
      const data = JSON.parse(responseText);

      // Create expanded results with only color variants
      const expandedResults = [];

      (data.results || []).forEach((product) => {
        // Find color option
        let colorOption = null;
        if (product.options && Array.isArray(product.options)) {
          colorOption = product.options.find(
            (option) =>
              option.name.toLowerCase().includes("color") ||
              option.name.toLowerCase().includes("colour")
          );
        }

        if (colorOption && product.variants && product.variants.length > 0) {
          // Get unique color values
          const colorPosition = colorOption.position - 1; // Shopify options are 1-indexed
          const seenColors = new Set();

          // For each color, find the first variant with that color
          product.variants.forEach((variant) => {
            if (!variant.options || !Array.isArray(variant.options)) return;

            const color = variant.options[colorPosition];
            if (!color || seenColors.has(color)) return;

            seenColors.add(color);

            // Find the matching color image if available
            let colorImage = variant.image || product.image;
            if (product.color_images && Array.isArray(product.color_images)) {
              const colorMatch = product.color_images.find(
                (img) => img.color === color
              );
              if (colorMatch && colorMatch.image_url) {
                // Use the image URL but replace the width if needed
                colorImage = colorMatch.image_url.replace(
                  /width=\d+/,
                  "width=300"
                );
              }
            }

            expandedResults.push({
              ...product,
              variantId: variant.id,
              variantColor: color,
              variantImage: colorImage,
              variantPrice: variant.price || product.price,
              variantAvailable: variant.available,
            });
          });
        } else {
          // No color variants, add the original product
          expandedResults.push(product);
        }
      });

      const resultsHTML = expandedResults
        .map((item) => {
          return `
        <div class="search-result-item${
          !item.variantAvailable ? " sold-out" : ""
        }">
          <a href="${item.url}${
            item.variantId ? "?variant=" + item.variantId : ""
          }">
             <img loading="lazy" src="${
               item.variantImage || item.image
             }" alt="${item.title} ${item.variantColor || ""}" width="80">
             <h3>${
               item.variantColor
                 ? `${item.title} ${item.variantColor}`
                 : item.title
             }</h3>
             <p>${item.variantPrice || item.price}</p>
             ${
               !item.variantAvailable
                 ? '<span class="sold-out-label">Sold Out</span>'
                 : ""
             }
           </a>
        </div>
      `;
        })
        .join("");

      resultsContainer.innerHTML = resultsHTML || "<p>No results found.</p>";
    } catch (error) {
      console.error("Error fetching search results:", error);
      resultsContainer.innerHTML = `<p>Error loading results. Please try again. ${error.message}</p>`;
    }
  });

document.addEventListener("DOMContentLoaded", () => {
  const navItems = document.querySelectorAll(".header-nav__item");
  const submenuBackground = document.querySelector(
      ".header-nav__submenu-background"
    ),
    resizeObserver = new ResizeObserver(() => {
      closeAllSubmenus();
    });

  resizeObserver.observe(document.body);
  const isTouch = window.matchMedia("(hover: none)").matches;

  // Close submenu when clicking outside
  document.addEventListener("click", (e) => {
    if (
      !e.target.closest(".header-nav__item") &&
      submenuBackground.classList.contains("active")
    ) {
      closeAllSubmenus();
    }
  });

  function closeAllSubmenus() {
    submenuBackground.classList.remove("active");
    document.querySelectorAll(".header-nav__submenu").forEach((submenu) => {
      submenu.classList.remove("active");
    });
  }

  navItems.forEach((item) => {
    const link = item.querySelector(".header-nav__link");
    const submenu = item.querySelector(".header-nav__submenu");

    if (isTouch) {
      // Touch device behavior
      link.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isVisible = submenuBackground.classList.contains("active");
        const isCurrentSubmenu = submenu.classList.contains("active");

        // Close all submenus first
        closeAllSubmenus();

        // If clicking the same item that was already open, don't reopen
        if (!isVisible || !isCurrentSubmenu) {
          submenuBackground.classList.add("active");
          submenu.classList.add("active");
        }
      });
    } else {
      // Mouse device behavior
      item.addEventListener("mouseenter", () => {
        submenuBackground.classList.add("active");
        submenu.classList.add("active");
      });

      item.addEventListener("mouseleave", () => {
        closeAllSubmenus();
      });

      // Keep focus handling for accessibility
      link.addEventListener("focus", () => {
        submenuBackground.classList.add("active");
        submenu.classList.add("active");
      });

      link.addEventListener("blur", () => {
        closeAllSubmenus();
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Function to handle quantity changes
  function handleQuantityChange() {
    const quantityInputs = document.querySelectorAll(
      ".cart-quantity .quantity__input"
    );

    quantityInputs.forEach((input) => {
      // Store original change handler
      const originalInputEvent = input.onchange;

      // Override the change event
      input.onchange = function (e) {
        const newQty = parseInt(this.value);

        // If quantity is 0, remove the item
        if (newQty === 0) {
          const variantId = this.dataset.quantityVariantId;
          removeFromCart(variantId);
        } else if (originalInputEvent) {
          // Otherwise run the original handler
          originalInputEvent.call(this, e);
        }
      };

      // Also handle clicks on the minus button
      const minusButton = input.previousElementSibling;
      minusButton.addEventListener("click", function () {
        const currentQty = parseInt(input.value);
        if (currentQty <= 1) {
          // Will become 0, so remove item
          const variantId = input.dataset.quantityVariantId;
          removeFromCart(variantId);
          // Prevent default behavior
          return false;
        }
      });
    });
  }

  // Function to remove item from cart
  function removeFromCart(variantId) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Refresh the cart drawer
        window.location.reload();
      })
      .catch((error) => console.error("Error:", error));
  }

  // Initialize after cart is loaded
  document.addEventListener("cart:refresh", handleQuantityChange);

  // Also initialize on page load
  handleQuantityChange();
});

// Slide-in Panel Functions
function openSlideIn(accordionToOpen) {
  // Open the slide-in panel
  document.getElementById("slideInPanel").classList.add("active");
  document.body.classList.add("overflow-hidden");
  document.querySelector(".header-wrapper").classList.add("active");

  // If an accordion ID is provided, open that accordion
  if (accordionToOpen) {
    // Find the corresponding header
    const accordionHeader = document.querySelector(
      `.accordion-header[data-target="${accordionToOpen}"]`
    );
    const accordionContent = document.getElementById(accordionToOpen);

    if (accordionHeader && accordionContent) {
      // First, close all accordions
      document.querySelectorAll(".accordion-header").forEach((header) => {
        header.classList.remove("active");
      });
      document.querySelectorAll(".accordion-content").forEach((content) => {
        content.classList.remove("active");
        if (window.accordionState) {
          window.accordionState[content.id] = false;
        }
      });

      // Open the specified accordion
      accordionHeader.classList.add("active");
      accordionContent.classList.add("active");
      if (window.accordionState) {
        window.accordionState[accordionToOpen] = true;
      }

      console.log("Auto-opening accordion:", accordionToOpen);
    }
  }
}

function closeSlideIn() {
  document.getElementById("slideInPanel").classList.remove("active");
  document.body.classList.remove("overflow-hidden");
  document.querySelector(".header-wrapper").classList.remove("active");
}

// Store reference to whether accordion code has been initialized
if (!window.accordionInitialized) {
  window.accordionInitialized = true;

  // Initialize Accordion functionality
  document.addEventListener("DOMContentLoaded", function () {
    console.log("Initializing accordion functionality");

    // Store accordion state in a variable outside event handlers
    window.accordionState = {};

    // Initialize all accordions as closed
    document.querySelectorAll(".accordion-content").forEach((content) => {
      // Remove inline styles and rely on CSS
      content.removeAttribute("style");
      content.classList.remove("active");
      window.accordionState[content.id] = false; // Set to closed
    });

    // Remove active class from all headers initially
    document.querySelectorAll(".accordion-header").forEach((header) => {
      header.classList.remove("active");

      // Remove any existing click listeners (if possible)
      const oldClickListener = header._clickListener;
      if (oldClickListener) {
        header.removeEventListener("click", oldClickListener);
      }

      // Create new click handler
      const clickHandler = function () {
        // Get content ID from data attribute
        const contentId = this.getAttribute("data-target");

        // Find the content element
        const content = document.getElementById(contentId);

        // Log the click for debugging
        console.log("Accordion clicked:", this.textContent.trim());

        if (!content) {
          console.error("Could not find accordion content with id:", contentId);
          return;
        }

        // Use our state object to determine current state
        const isOpen = window.accordionState[contentId];
        console.log("Current state:", isOpen ? "open" : "closed");

        // Toggle the accordion based on our stored state
        if (isOpen) {
          // Currently open, so close it
          console.log("Closing accordion:", contentId);
          this.classList.remove("active");
          content.classList.remove("active");
          window.accordionState[contentId] = false;
        } else {
          // Currently closed, so open it
          console.log("Opening accordion:", contentId);
          this.classList.add("active");
          content.classList.add("active");
          window.accordionState[contentId] = true;
        }
      };

      // Store the click handler for future reference
      header._clickListener = clickHandler;

      // Add the click handler
      header.addEventListener("click", clickHandler);
    });

    // Product Info Links click handler
    const productInfoLinks = document.querySelectorAll(".product-info-link");
    productInfoLinks.forEach((link) => {
      // Remove any existing click event from the onclick attribute
      link.removeAttribute("onclick");

      // Add a new click handler
      link.addEventListener("click", function () {
        // Get the accordion to open from the data attribute
        const accordionId = this.getAttribute("data-accordion");

        // Open the slide-in panel and the specified accordion
        openSlideIn(accordionId);
      });
    });

    // Check if the panel overlay exists
    const overlayElement = document.getElementById("SlideInPanel-Overlay");
    if (overlayElement) {
      overlayElement.addEventListener("click", function (event) {
        event.stopPropagation();
        closeSlideIn();
      });
    }
  });
}

if (window.customCodeInitialized) {
  console.log("Custom code already initialized, skipping");
} else {
  window.customCodeInitialized = true;

  document.addEventListener("DOMContentLoaded", () => {
    console.log("DOMContentLoaded - executing only once");
    // Rest of your code
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Select the fieldset with the class product-form__input--size
  const sizeFieldset = document.querySelector(".product-form__input--size");
  const addToBagButton = document.querySelector(".product-form__submit");

  // Function to check if it's a touch device
  function isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
  }

  // Function to update button text
  function updateButtonText(button, text) {
    const buttonTextSpan = button.querySelector("span");
    if (buttonTextSpan) {
      buttonTextSpan.textContent = text;
    } else {
      button.textContent = text;
    }
  }

  // Check if the elements exist before proceeding
  if (sizeFieldset && addToBagButton) {
    const sizeInput = sizeFieldset.querySelector("input"); // Assuming the input is within the fieldset
    const sizeOptions = sizeFieldset.querySelectorAll("input[type='radio']");
    if (
      sizeOptions.length === 1 ||
      (sizeInput && sizeInput.value.toLowerCase() === "one size")
    ) {
      return; // Exit early if there is only one size to choose
    }
    // Add the initially-disabled class
    sizeFieldset.classList.add("initially-disabled");
    addToBagButton.classList.add("initially-disabled");
    addToBagButton.disabled = true;

    // Add a click event listener to remove the class
    sizeFieldset.addEventListener("click", () => {
      sizeFieldset.classList.remove("initially-disabled");
      addToBagButton.classList.remove("initially-disabled");
      addToBagButton.disabled = false;
    });

    // Get the button text span element instead of direct text content
    const buttonTextSpan = addToBagButton.querySelector("span");
    const originalText = buttonTextSpan
      ? buttonTextSpan.textContent
      : addToBagButton.textContent;

    addToBagButton.addEventListener("mouseenter", () => {
      if (addToBagButton.classList.contains("initially-disabled")) {
        // Update the text in the span if it exists, otherwise update the button directly
        if (buttonTextSpan) {
          buttonTextSpan.textContent = "PLEASE SELECT SIZE";
        } else {
          addToBagButton.textContent = "PLEASE SELECT SIZE";
        }
      }
    });

    addToBagButton.addEventListener("mouseleave", () => {
      if (addToBagButton.classList.contains("initially-disabled")) {
        if (buttonTextSpan) {
          buttonTextSpan.textContent = originalText;
        } else {
          addToBagButton.textContent = originalText;
        }
      }
    });
  }

  // For touch devices, show "PLEASE SELECT SIZE" until fieldset is clicked
  if (isTouchDevice()) {
    let hasBeenClicked = false;

    if (sizeFieldset && addToBagButton) {
      const buttonTextSpan = addToBagButton.querySelector("span");
      const originalText = buttonTextSpan
        ? buttonTextSpan.textContent
        : addToBagButton.textContent;

      // Show "PLEASE SELECT SIZE" initially
      if (addToBagButton.classList.contains("initially-disabled")) {
        updateButtonText(addToBagButton, "PLEASE SELECT SIZE");
      }

      // Reset to original text after fieldset is clicked
      sizeFieldset.addEventListener("click", () => {
        hasBeenClicked = true;
        updateButtonText(addToBagButton, originalText);
      });
    }
  } else if (!isTouchDevice()) {
    // For non-touch devices, show original text
    if (sizeFieldset && addToBagButton) {
      const buttonTextSpan = addToBagButton.querySelector("span");
      const originalText = buttonTextSpan
        ? buttonTextSpan.textContent
        : addToBagButton.textContent;

      if (addToBagButton.classList.contains("initially-disabled")) {
        updateButtonText(addToBagButton, originalText);
      }
    }
  }
});
